var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6562 1.15625C16.9062 1.3125 17.0312 1.59375 16.9375 1.875L14.9375 15.375C14.9062 15.5938 14.7812 15.8125 14.5625 15.9062C14.4688 15.9688 14.3438 16.0312 14.2188 16.0312C14.0938 16.0312 14 16 13.9062 15.9688L10.8438 14.6562L7.375 16.9062C7.25 16.9688 7.09375 17 6.96875 17C6.875 17 6.75 16.9688 6.625 16.9375C6.375 16.7812 6.25 16.5312 6.25 16.25V12.7188L1.4375 10.7188C1.1875 10.5938 1 10.3438 1 10.0625C0.96875 9.78125 1.125 9.5 1.375 9.375L15.875 1.125C16.125 0.96875 16.4375 1 16.6562 1.15625ZM12.5312 4.75L3.4375 9.90625L6.6875 11.2812L12.5312 4.75ZM7.71875 14.875L9.15625 13.9688L7.71875 13.3438V14.875ZM13.625 14.1875L15.125 4.09375L8.125 11.875L13.625 14.1875Z",
    fill: "#4E535F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.0e7c0772b4466f04bef53b13662db8d1.svg";
export { ForwardRef as ReactComponent };